import {Component, Input} from '@angular/core';
import {DownloadInfoWithLineItem} from '../../shopping-cart/download.service';
import {SpinnerComponent} from '../../svg/spinner/spinner.component';
import {NgForOf, NgIf} from '@angular/common';
import {DownloadItemComponent} from './download-item/download-item.component';

@Component({
  selector: 'app-download-list',
  templateUrl: './download-list.component.html',
  styleUrls: ['./download-list.component.scss'],
  standalone: true,
  imports: [
    SpinnerComponent,
    NgIf,
    DownloadItemComponent,
    NgForOf
  ]
})
export class DownloadListComponent {
  @Input() downloadItems?: readonly DownloadInfoWithLineItem[];

  constructor() {
  }

  get itemsAvailable() {
    return !!this.downloadItems?.length;
  }

}
